import { Lead } from 'entities/Lead';
import { User } from 'entities/User';
import { WaitingListEntry } from 'entities/WaitingListEntry';

export interface WaitingListEntryDrawerSchema {
  mode: Nullable<DrawerMode>;
  waitingListEntry?: Nullable<WaitingListEntry>;
  lead?: Nullable<Lead>;
  user?: Nullable<User>;
}

export enum DrawerMode {
  EDIT = 'edit',
  CREATE = 'create',
}
